import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-cloud-cta-banner',
    templateUrl: './block-cloud-cta-banner.component.html',
})

export class BlockCloudCTABannerComponent extends BlockAbstractComponent implements OnInit {

}
